import {
  AppData,
  CalcMode,
  Converter,
} from "../../interface/functionalityInterface";
import { Area } from "../baseQuantities/area";
import { Flow } from "../baseQuantities/flow";
import { Force } from "../baseQuantities/force";
import { Length } from "../baseQuantities/length";
import { Mass } from "../baseQuantities/mass";
import { Pressure } from "../baseQuantities/pressure";
import { Temperature } from "../baseQuantities/temperature";
import { Time } from "../baseQuantities/time";
import { Velocity } from "../baseQuantities/velocity";
import { Volume } from "../baseQuantities/volume";

const includedBaseQuantities = [
  Length,
  Area,
  Volume,
  Velocity,
  Time,
  Temperature,
  Mass,
  Force,
  Flow,
  Pressure,
];

const baseQuantities: CalcMode[] = includedBaseQuantities.map((bq) => {
  return {
    id: `001${bq.name}`,
    name: bq.name,
    baseQuantities: [bq, bq],
  };
});

export const converterCalc: Converter = {
  type: AppData.CONVERTER,
  name: "converter",
  updatedAt: "2022-08-17",
  inputs: baseQuantities,
};
